var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"top-w",style:('bottom:' + _vm.bottom),on:{"click":_vm.backTop}})])
}
var staticRenderFns = []

export { render, staticRenderFns }